import {
  Flex,
  Button,
  Text,
  Select,
  HStack,
} from "@chakra-ui/react";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  itemsPerPage: number;
  totalItems: number;
  onPageChange: (page: number) => void;
  onItemsPerPageChange: (items: number) => void;
}

export const Pagination = ({
  currentPage,
  totalPages,
  itemsPerPage,
  totalItems,
  onPageChange,
  onItemsPerPageChange,
}: PaginationProps) => {
  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <Flex justify="space-between" align="center" mt={4} wrap="wrap" gap={4}>
      <HStack spacing={2}>
        <Text fontSize="sm" color="gray.400">
          Show
        </Text>
        <Select
          size="sm"
          w="auto"
          value={itemsPerPage}
          onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
          bg="gray.800"
          borderColor="gray.600"
          color="gray.300"
        >
          <option value={10}>10</option>
          <option value={25}>25</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </Select>
        <Text fontSize="sm" color="gray.400">
          entries
        </Text>
      </HStack>

      <Text fontSize="sm" color="gray.400">
        Showing {startItem} to {endItem} of {totalItems} entries
      </Text>

      <HStack spacing={1}>
        <Button
          size="sm"
          variant="outline"
          borderColor="gray.600"
          color="gray.300"
          _hover={{ bg: "gray.700" }}
          isDisabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
        >
          <ChevronLeftIcon />
        </Button>
        
        {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
          let pageNumber;
          if (totalPages <= 5) {
            pageNumber = i + 1;
          } else if (currentPage <= 3) {
            pageNumber = i + 1;
          } else if (currentPage >= totalPages - 2) {
            pageNumber = totalPages - 4 + i;
          } else {
            pageNumber = currentPage - 2 + i;
          }
          
          return (
            <Button
              key={pageNumber}
              size="sm"
              variant={currentPage === pageNumber ? "solid" : "outline"}
              colorScheme={currentPage === pageNumber ? "brand" : undefined}
              borderColor="gray.600"
              color={currentPage === pageNumber ? "white" : "gray.300"}
              _hover={{ bg: currentPage === pageNumber ? "brand.700" : "gray.700" }}
              onClick={() => onPageChange(pageNumber)}
            >
              {pageNumber}
            </Button>
          );
        })}
        
        <Button
          size="sm"
          variant="outline"
          borderColor="gray.600"
          color="gray.300"
          _hover={{ bg: "gray.700" }}
          isDisabled={currentPage === totalPages}
          onClick={() => onPageChange(currentPage + 1)}
        >
          <ChevronRightIcon />
        </Button>
      </HStack>
    </Flex>
  );
};

export default Pagination;